import {
  GET_FILE_PDF,
  GET_INCLUSIONS,
  GET_INCLUSIONS_SUMMARY,
  SET_INCLUSIONS_USER_SETTINGS, UPDATE_INCLUSION_MAKER_READED
} from '../constants/inclusionConstants';
import {IUserSettings} from '../reducers/inclusionsReducers';

export function getInclusionSummary(patientId: number | null, resolve: any, reject:any) {
  return {type: GET_INCLUSIONS_SUMMARY, patientId, resolve, reject}
}

export function getInclusions(limit: number,
                              page: number, read: boolean, patientId: number | null, resolve: any, reject: any) {
  return {type: GET_INCLUSIONS, limit, page, read, patientId, resolve, reject}
}

export function getFilePdf(fileId: number, resolve: any, reject: any){
  return { type: GET_FILE_PDF, resolve, reject, fileId }
}

export function setInclusionsUsersSetting(userSettings: IUserSettings) {
  return {
    type: SET_INCLUSIONS_USER_SETTINGS, userSettings
  }
}

export function updateInclusionMakerReaded(
    implantEnrollmentId: string,
    maker_readed: boolean,
    resolve: any,
    reject: any,
) {
  console.log(`action implantEnrollmentId ${implantEnrollmentId}`)
  return {
    type: UPDATE_INCLUSION_MAKER_READED,
    implantEnrollmentId,
    maker_readed,
    resolve,
    reject
  }
}
